import { MonthThermalComfortInfo } from './types';

export const DISABLED_DATA_INFO: MonthThermalComfortInfo = {
  TYPE: 'month',
  HISTORY: [
    {
      MONTH: 1, YEAR: 2025, PERCENTAGE_COMFORTABLE: 100, PERCENTAGE_BELOW_LIMIT: 0, PERCENTAGE_ABOVE_LIMIT: 0, PERCENTAGE_INOPERATIVE: 0, TOTAL_UNITS_COMFORTABLE: 0, TOTAL_UNITS_BELOW_LIMIT: 0, TOTAL_UNITS_ABOVE_LIMIT: 0, TOTAL_UNITS_INOPERATIVE: 0,
    },
    {
      MONTH: 2, YEAR: 2025, PERCENTAGE_COMFORTABLE: 100, PERCENTAGE_BELOW_LIMIT: 0, PERCENTAGE_ABOVE_LIMIT: 0, PERCENTAGE_INOPERATIVE: 0, TOTAL_UNITS_COMFORTABLE: 0, TOTAL_UNITS_BELOW_LIMIT: 0, TOTAL_UNITS_ABOVE_LIMIT: 0, TOTAL_UNITS_INOPERATIVE: 0,
    },
    {
      MONTH: 3, YEAR: 2025, PERCENTAGE_COMFORTABLE: 100, PERCENTAGE_BELOW_LIMIT: 0, PERCENTAGE_ABOVE_LIMIT: 0, PERCENTAGE_INOPERATIVE: 0, TOTAL_UNITS_COMFORTABLE: 0, TOTAL_UNITS_BELOW_LIMIT: 0, TOTAL_UNITS_ABOVE_LIMIT: 0, TOTAL_UNITS_INOPERATIVE: 0,
    },
    {
      MONTH: 4, YEAR: 2025, PERCENTAGE_COMFORTABLE: 100, PERCENTAGE_BELOW_LIMIT: 0, PERCENTAGE_ABOVE_LIMIT: 0, PERCENTAGE_INOPERATIVE: 0, TOTAL_UNITS_COMFORTABLE: 0, TOTAL_UNITS_BELOW_LIMIT: 0, TOTAL_UNITS_ABOVE_LIMIT: 0, TOTAL_UNITS_INOPERATIVE: 0,
    },
    {
      MONTH: 5, YEAR: 2025, PERCENTAGE_COMFORTABLE: 100, PERCENTAGE_BELOW_LIMIT: 0, PERCENTAGE_ABOVE_LIMIT: 0, PERCENTAGE_INOPERATIVE: 0, TOTAL_UNITS_COMFORTABLE: 0, TOTAL_UNITS_BELOW_LIMIT: 0, TOTAL_UNITS_ABOVE_LIMIT: 0, TOTAL_UNITS_INOPERATIVE: 0,
    },
    {
      MONTH: 6, YEAR: 2025, PERCENTAGE_COMFORTABLE: 100, PERCENTAGE_BELOW_LIMIT: 0, PERCENTAGE_ABOVE_LIMIT: 0, PERCENTAGE_INOPERATIVE: 0, TOTAL_UNITS_COMFORTABLE: 0, TOTAL_UNITS_BELOW_LIMIT: 0, TOTAL_UNITS_ABOVE_LIMIT: 0, TOTAL_UNITS_INOPERATIVE: 0,
    },
    {
      MONTH: 7, YEAR: 2025, PERCENTAGE_COMFORTABLE: 100, PERCENTAGE_BELOW_LIMIT: 0, PERCENTAGE_ABOVE_LIMIT: 0, PERCENTAGE_INOPERATIVE: 0, TOTAL_UNITS_COMFORTABLE: 0, TOTAL_UNITS_BELOW_LIMIT: 0, TOTAL_UNITS_ABOVE_LIMIT: 0, TOTAL_UNITS_INOPERATIVE: 0,
    },
  ],
};
